import clarity from '@microsoft/clarity';

export interface ClarityConfig {
  projectId: string;
  enabled?: boolean;
}

/**
 * Inicializa o Microsoft Clarity
 * @param config Configuração do Clarity
 */
export const initializeClarity = (config: ClarityConfig) => {
  if (!config.enabled || !config.projectId) {
    console.log('Microsoft Clarity não inicializado - desabilitado ou sem projectId');
    return;
  }

  try {
    clarity.init(config.projectId);
    console.log('Microsoft Clarity inicializado com sucesso:', config.projectId);
  } catch (error) {
    console.error('Erro ao inicializar Microsoft Clarity:', error);
  }
};

/**
 * Identifica um usuário no Clarity
 * @param userId ID único do usuário
 * @param sessionId ID da sessão (opcional)
 * @param pageId ID da página (opcional)
 * @param friendlyName Nome amigável do usuário (opcional)
 */
export const identifyUser = (
  userId: string,
  sessionId?: string,
  pageId?: string,
  friendlyName?: string
) => {
  try {
    clarity.identify(userId, sessionId, pageId, friendlyName);
    console.log('Usuário identificado no Clarity:', { userId, friendlyName });
  } catch (error) {
    console.error('Erro ao identificar usuário no Clarity:', error);
  }
};

/**
 * Define tags customizadas no Clarity
 * @param key Chave da tag
 * @param value Valor da tag
 */
export const setCustomTag = (key: string, value: string | string[]) => {
  try {
    clarity.setTag(key, value);
    console.log('Tag customizada definida no Clarity:', { key, value });
  } catch (error) {
    console.error('Erro ao definir tag customizada no Clarity:', error);
  }
};

/**
 * Envia evento customizado para o Clarity
 * @param eventName Nome do evento
 */
export const trackEvent = (eventName: string) => {
  try {
    clarity.event(eventName);
    console.log('Evento enviado para o Clarity:', { eventName });
  } catch (error) {
    console.error('Erro ao enviar evento para o Clarity:', error);
  }
};

/**
 * Obtém informações da sessão do Clarity
 * Para obter a URL da sessão, consulte o dashboard do Clarity
 */
export const getSessionInfo = () => {
  console.log('Para visualizar a sessão, acesse o dashboard do Microsoft Clarity');
};